const multiSelectOptions = {
  ransackParams: (filters, filterKey, filterValue) => (
    { [`q[${filters[filterKey].ransackLabel}]`]: filterValue }
  ),
  setupFilters: defaultValue => defaultValue || [],
  handleFilterChange: (event, allFilters, nameOfFilter) => {
    const changedInput = event.currentTarget.value;
    const filtersForChangedInput = allFilters[nameOfFilter];
    let updatedFilter;

    if (filtersForChangedInput.includes(changedInput)) {
      updatedFilter = filtersForChangedInput.filter(id => id !== changedInput);
    } else {
      updatedFilter = [...filtersForChangedInput, changedInput];
    }

    return { ...allFilters, [nameOfFilter]: updatedFilter };
  },
  removeFilter: ({ allFilters, nameOfFilter, filterKey }) => {
    const updatedFilter = allFilters[nameOfFilter].filter(id => id !== filterKey);
    return { ...allFilters, [nameOfFilter]: updatedFilter };
  }
};

const accordionOption = {
  ...multiSelectOptions,
  handleFilterChange: (event, allFilters, nameOfFilter, filterKey, childObject) => {
    if (childObject) {
      const changedInput = event.currentTarget.value;
      const filtersForChangedInput = allFilters[nameOfFilter];
      let updatedFilter, childFilterValues;

      if (filtersForChangedInput.includes(changedInput)) {
        updatedFilter = filtersForChangedInput.filter(id => id !== changedInput);
        const removeParentValues = childObject && childObject.values.map(option => option.value);
        childFilterValues = childObject && allFilters[childObject.label]
          .filter(option => !removeParentValues.includes(option));
      } else {
        updatedFilter = [...filtersForChangedInput, changedInput];
        const additionalChildFilterValues = childObject && childObject.values.map(option => option.value);
        childFilterValues = [...allFilters[childObject.label], ...additionalChildFilterValues];
      }

      return {
        ...allFilters,
        [nameOfFilter]: updatedFilter,
        [childObject.label]: childFilterValues
      };
    } else {
      return multiSelectOptions.handleFilterChange(event, allFilters, nameOfFilter);
    }
  }
};

// TODO: Make a better version of this for search
const searchOption = {
  ...multiSelectOptions,
  setupFilters: () => '',
};

const selectOption = {
  ransackParams: (filters, filterKey, filterValue) => (
    { [`q[${filters[filterKey].ransackLabel}]`]: filterValue }
  ),
  setupFilters: defaultValue => defaultValue || 'any',
  handleFilterChange: (event, allFilters, nameOfFilter) => {
    return { ...allFilters, [nameOfFilter]: event.currentTarget.value };
  }
};

const sharedMinMaxOptions = {
  ransackParams: (filters, filterKey, filterValue) => {
    const params = {};

    if (filterValue.min !== '') {
      params[`q[${filters[filterKey].ransackLabel}_gteq]`] = filterValue.min;
    }
    if (filterValue.max !== '') {
      params[`q[${filters[filterKey].ransackLabel}_lteq]`] = filterValue.max;
    }

    return params;
  },
  setupFilters: () => ({ min: '', max: '' }),
  handleFilterChange: (event, allFilters, nameOfFilter, filterKey) => {
    const filtersForChangedInput = allFilters[nameOfFilter];
    return {
      ...allFilters,
      [nameOfFilter]: { ...filtersForChangedInput, [filterKey]: event.currentTarget.value }
    };
  },
  removeFilter: ({ allFilters, nameOfFilter, filterKey }) => (
    { ...allFilters, [nameOfFilter]: { ...allFilters[nameOfFilter], [filterKey]: '' } }
  )
};

const childFilterOptions = {
  setupFilters: () => false,
  removeFilter: ({ allFilters, filterData }) => (
    { ...allFilters, [filterData.childFilter.key]: false }
  ),
  ransackParams: (filters, filterKey, filterValue) => (
    { [`q[${filters[filterKey].childFilter.ransackLabel}]`]: filterValue }
  ),
};

export const savedReportsUrl = '/saved_reports';
export const CHILD_FILTER_TYPE = 'child';

export const filterTypeOptions = {
  'accordion': accordionOption,
  'search': searchOption,
  'multiselect': multiSelectOptions,
  'dropdown': multiSelectOptions,
  'range': sharedMinMaxOptions,
  'date': sharedMinMaxOptions,
  'select': selectOption,
  [CHILD_FILTER_TYPE]: childFilterOptions
};
